module.exports = __webpack_public_path__ + "static/img/step_2-button.ce17d044.png";